export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/ZenKakuGothicNew-Bold.0081ceda-e9bb0e.ttf";